// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"1fab0d1cb3ce17aaf55d","678":"7a68c9da6fd73b873147","731":"30ba07d10f59b84ffe2d","843":"4d22e4d87d98fa226c97","883":"39675934bbfa1199c3c2"}[chunkId] + ".js";
};